export function JeepIcon(props: React.HTMLAttributes<SVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      viewBox="0 0 1000 403.21"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M0 0c-.12-6.621 1.31-10.128 6.768-10.128 5.449 0 6.231 5.974 6.231 10.52 0 4.549-1.034 8.965-6.759 8.965C2.728 9.357.135 6.628 0 0zm-11.042-27.668V17.15H.135v-1.818c0-2.425.978-1.425 1.766-.48.132.158 2.623 3.207 8.233 3.207 5.593 0 14.294-3.896 14.294-17.667 0-10.652-5.191-18.445-14.156-18.445-4.94 0-7.796 1.945-8.449 2.73-.654.774-1.562.909-1.562 0v-12.345h-11.303"
        fill="#231f20"
        fillOpacity={1}
        fillRule="nonzero"
        stroke="none"
        transform="matrix(6.77532 0 0 -6.77532 833.993 215.25)"
      />
      <path
        d="M0 0h12.082v-31.696c0-5.452-2.341-16.887-19.096-16.887-16.757 0-18.575 10.658-18.575 16.629v5.845h11.692v-5.713c0-3.507 2.339-6.753 6.753-6.753 4.416 0 7.144 2.467 7.144 6.621V0"
        fill="#231f20"
        fillOpacity={1}
        fillRule="nonzero"
        stroke="none"
        transform="matrix(6.77532 0 0 -6.77532 173.874 .5)"
      />
      <path
        d="M0 0c0 3.251-1.815 6.368-5.972 6.368-4.027 0-5.457-2.855-5.457-6.368H0zm-7.137 13.641c9.488 0 17.798-3.636 17.798-20.394H-11.81c0-5.326 2.206-7.535 6.103-7.535 3.898 0 5.196 3.12 5.196 3.12h11.045c0-4.808-6.626-11.303-16.631-11.174-11.428 0-17.015 8.444-17.015 17.148 0 8.707 4.933 18.835 15.975 18.835"
        fill="#231f20"
        fillOpacity={1}
        fillRule="nonzero"
        stroke="none"
        transform="matrix(6.77532 0 0 -6.77532 426.925 182.675)"
      />
      <path
        d="M0 0c0 3.251-1.817 6.368-5.974 6.368-4.025 0-5.458-2.855-5.458-6.368H0zm-7.137 13.641c9.487 0 17.795-3.636 17.795-20.394h-22.47c0-5.326 2.208-7.535 6.108-7.535 3.894 0 5.194 3.12 5.194 3.12h11.045c0-4.808-6.627-11.303-16.629-11.174-11.434 0-17.021 8.444-17.021 17.148 0 8.707 4.939 18.835 15.978 18.835"
        fill="#231f20"
        fillOpacity={1}
        fillRule="nonzero"
        stroke="none"
        transform="matrix(6.77532 0 0 -6.77532 670.315 182.675)"
      />
      <path
        d="M0 0a3.223 3.223 0 0 0 3.226 3.217 3.22 3.22 0 0 0 0-6.44A3.23 3.23 0 0 0 0 0zm-.372 0a3.597 3.597 0 0 1 3.598-3.598A3.602 3.602 0 0 1 6.82 0a3.602 3.602 0 0 1-3.594 3.598A3.597 3.597 0 0 1-.372 0"
        fill="#231f20"
        fillOpacity={1}
        fillRule="nonzero"
        stroke="none"
        transform="matrix(6.77532 0 0 -6.77532 949.376 366.306)"
      />
      <path
        d="m0 0-.747 1.764c.237.082.316.14.442.275.164.176.267.454.267.706 0 .636-.489 1.069-1.198 1.069h-1.5V0h.445v1.652h1.084L-.495 0H0zm-2.303 2.039v1.36h1.058c.442 0 .723-.252.723-.642 0-.443-.298-.718-.785-.718h-.996"
        fill="#231f20"
        fillOpacity={1}
        fillRule="nonzero"
        stroke="none"
        transform="matrix(6.77532 0 0 -6.77532 980.997 378.773)"
      />
    </svg>
  )
}
